import React, { useCallback, useEffect } from "react";
import styles from "./SpotlightrQuizModal.module.css";
import classNames from "classnames";
import { IUserTrainingCourseSummary } from "src/@types/ImpiricaPlatformApi";
import useScript from "react-script-hook";
import { toast } from "react-toastify";
import { Modal } from "antd";

type SpotlightrQuizModalProps = {
	course: IUserTrainingCourseSummary;
	/** passed, plus the raw results object from the player - the server stores it as evidence */
	onComplete?: (passed: boolean, results: unknown) => void;
	onClose?: () => void;
};

const SpotlightrQuizModal: React.FC<SpotlightrQuizModalProps> = ({
	course,
	onComplete,
	onClose,
}) => {
	const { quizId, title, quizUrl } = course;
	const [scriptLoading] = useScript({
		src: "https://training.impirica.tech/assets/spotlightr.js",
	});

	const _vooPlayerReady = useCallback(
		(event: any) => {
			console.log("vooPlayerReady", event.detail);
			window.spotlightrAPI(quizId, "quizFinished", null, _quizFinished);
			// No "play" here: an external play before the first start makes the player mute itself, and "volume"
			// cannot undo it, so the learner's own click starts the quiz with sound.
		},
		[quizId]
	);

	const _quizFinished = useCallback(
		async (results: any) => {
			if (results.passed) {
				toast.success("Congratulations! You passed the quiz.");
			} else {
				toast.error("Sorry, you did not pass the quiz.");
			}
			if (onComplete) {
				onComplete(results.passed, results);
			}
		},
		[quizId]
	);

	useEffect(() => {
		if (scriptLoading) return;

		document.addEventListener("vooPlayerReady", _vooPlayerReady);
		return () => {
			document.removeEventListener("vooPlayerReady", _vooPlayerReady);
		};
	}, [scriptLoading]);

	return (
		<Modal
			visible={!!course}
			closable
			onCancel={onClose}
			footer={null}
			width={896}
			title={`${title} Quiz`}
		>
			<div className={styles.quiz} data-testid="quiz-content">
				<iframe
					allow="autoplay"
					className={classNames(
						"video-player-container",
						"spotlightr",
						styles.quizFrame
					)}
					data-playerid={quizId}
					name="videoPlayerframe"
					allowFullScreen
					src={quizUrl}
				>
					{" "}
				</iframe>
			</div>
		</Modal>
	);
};

export default SpotlightrQuizModal;
